export const licenseFormatTypeEnum = Object.freeze({
  physical: 1,
  digital: 2,
  both: 3,
});
